import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=08837983&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08837983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08837983')) {
      api.createRecord('08837983', component.options)
    } else {
      api.reload('08837983', component.options)
    }
    module.hot.accept("./shopList.vue?vue&type=template&id=08837983&scoped=true", function () {
      api.rerender('08837983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/shopList.vue"
export default component.exports